// Firebase initialization and exports
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyBR3W3zAA7wgF3kdJq6Bmt9p9kX00Tj8NI",
  authDomain: "pramila-foundation.firebaseapp.com",
  projectId: "pramila-foundation",
  storageBucket: "pramila-foundation.firebasestorage.app",
  messagingSenderId: "1004956773501",
  appId: "1:1004956773501:web:112fc59f859edc55cd5514",
  measurementId: "G-8G4X4B04QP"
}

const app = initializeApp(firebaseConfig)
try { getAnalytics(app) } catch (e) { /* analytics optional */ }

export const auth = getAuth(app)
export const db = getFirestore(app)
export default app
